import type {PropsWithChildren} from 'react';

import {Link} from '@/modules/foundation/components/link';

type Props = PropsWithChildren & {
	href?: string;
	targetBlank?: boolean;
	className?: string;
};

export const PortableLink = ({children, href, targetBlank, className}: Props) => {
	return (
		<Link href={href} targetBlank={targetBlank} className={className}>
			{children}
		</Link>
	);
};
